import styled from 'styled-components';
import { Screen, screenBiggerThan } from '@client/styles/styled-components/breakpoints';
import { Color } from '@lux/tokens';
import { Title } from '@lux/title';

export const Wrapper = styled.div<{ $isSmallThbVariant?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;

    background-color: ${Color.bright};
    position: absolute;
    min-width: 138px;
    max-width: 320px;
    padding: 12px;
    z-index: 100;
    bottom: ${props => (props.$isSmallThbVariant ? '16px' : '32px')};

    ${screenBiggerThan(Screen.smallTablet)} {
        padding: 20px;
        min-width: 176px;
        cursor: default;

`;

export const THBTitle = styled(Title)`
    margin: 0 0 8px 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    /* line clamp alternative for ie11 */
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
    }
`;
